export default {
    state: {
        calcStatus: 0,

        calcRes: 0,
        calcParam: {
            style: 0,
            area: 0,
            height: 0,
            areaSecond: 0,
            wallColor: 0,
            floorColor: 0
        }
    },
    mutations: {
        plusStatus: (state) => {
            state.calcStatus++

        },
        minusStatus: (state) => {
            state.calcStatus--
        },

        updResult: (state) => {

            let result = 0;
            result = result + state.calcParam.style
            result = result + (state.calcParam.area * 1500)
            result = result + (state.calcParam.height * 10000)
            result = result + (state.calcParam.areaSecond * 3000)
            result = result + state.calcParam.wallColor
            result = result + state.calcParam.floorColor

            state.calcRes = result
        },
        resetResult: (state) => {
            state.calcStatus = 1
            state.calcParam.style = 0
            state.calcParam.area = 0
            state.calcParam.height = 0
            state.calcParam.areaSecond = 0
            state.calcParam.wallColor = 0
            state.calcParam.floorColor = 0
        },
        closeCalc: (state) => {
            state.calcStatus = 0
            state.calcParam.style = 0
            state.calcParam.area = 0
            state.calcParam.height = 0
            state.calcParam.areaSecond = 0
            state.calcParam.wallColor = 0
            state.calcParam.floorColor = 0
        },
    },
    actions: {
        calcStatusPlus ({commit}) {
            commit('plusStatus')
        },
        calcStatusMinus ({commit}) {
            commit('minusStatus')
        },

        resultCalc ({commit}) {
            commit('updResult')
        },
        resetResult ({commit}) {
            commit('resetResult')
        },
        close ({commit}) {
            commit('closeCalc')
        }
    },
    getters: {
        calculateStatus (state) {
            return state.calcStatus
        },

        calculateResult (state) {
            return state.calcRes
        },
        calculateParameters (state) {
            return state.calcParam
        }
    }
}
